import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["reminderField", "attachment"]

  connect() {
    $('#attachments').tooltip({ selector: '.fa-file-icon' });
  }

  toggleReminder(event) {
    this.reminderFieldTarget.classList.toggle('hidden', !event.target.checked);
    if (!event.target.checked) document.querySelector("#document_package_send_reminder_at")._flatpickr.clear();
  }

  selectAll() {
    this.attachmentTargets.forEach(t => t.checked = true)
  }

  selectNone() {
    this.attachmentTargets.forEach(t => t.checked = false)
  }
}
